/* eslint-disable no-throw-literal */
import {
  GET_COMPANY_NOTICE_LIST,
  GET_COMPANY_NOTICE,
  CREATE_COMPANY_NOTICE,
  UPDATE_COMPANY_NOTICE,
  DELETE_COMPANY_NOTICE,
  GET_COMPANY_NOTICE_RESULT_CSV
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_COMPANY_NOTICE_LIST] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/company_notices', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_COMPANY_NOTICE] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/company_notices/' + params.id })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [CREATE_COMPANY_NOTICE] ({ dispatch }, params) {
      const res = await dispatch('apiPost', { url: `/master/company_notices/`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [UPDATE_COMPANY_NOTICE] ({ dispatch }, params) {
      const res = await dispatch('apiPatch', { url: `/master/company_notices/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [DELETE_COMPANY_NOTICE] ({ dispatch }, params) {
      const res = await dispatch('apiDelete', { url: `/master/company_notices/${params.data.id}`, data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    async [GET_COMPANY_NOTICE_RESULT_CSV] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/company_notices/notice_csv', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/company-notice.js